"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderSlice = exports.fetchUpdateOrder = exports.fetchUpdateCoupon = exports.fetchGetOrder = exports.fetchCreateOrder = exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toolkit = require("@reduxjs/toolkit");
var _api = require("../api");
var _Input = require("../components/Input");
var _extraReducers;
var initialState = {
  order: {
    priceBreakdown: {
      offerPrice: 0,
      discountAmount: 0,
      taxValue: 0,
      customerServiceFee: 0,
      paymentMethodFee: 0
    },
    discount: {
      applied: false
    },
    taxRate: 0,
    country: '',
    currency: '',
    totalPrice: 0
  },
  loading: true,
  error: null,
  couponDetails: {
    showMessage: false,
    message: '',
    messageType: _Input.MESSAGE_TYPE_SUCCESS
  },
  isCouponLoading: false,
  couponError: null,
  isUpdateLoading: false
};
var fetchCreateOrder = (0, _toolkit.createAsyncThunk)('order/createOrder', /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(offerId, _ref) {
    var rejectWithValue, _yield$createOrder, order;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          rejectWithValue = _ref.rejectWithValue;
          _context.prev = 1;
          _context.next = 4;
          return (0, _api.createOrder)(offerId);
        case 4:
          _yield$createOrder = _context.sent;
          order = _yield$createOrder.order;
          return _context.abrupt("return", order);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", rejectWithValue(_context.t0.message));
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 9]]);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
exports.fetchCreateOrder = fetchCreateOrder;
var fetchUpdateOrder = (0, _toolkit.createAsyncThunk)('order/updateOrder', /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(_ref3, _ref4) {
    var id, payload, rejectWithValue, _yield$updateOrder, order;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          id = _ref3.id, payload = _ref3.payload;
          rejectWithValue = _ref4.rejectWithValue;
          _context2.prev = 2;
          _context2.next = 5;
          return (0, _api.updateOrder)(id, payload);
        case 5:
          _yield$updateOrder = _context2.sent;
          order = _yield$updateOrder.order;
          return _context2.abrupt("return", order);
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", rejectWithValue(_context2.t0.message));
        case 13:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 10]]);
  }));
  return function (_x3, _x4) {
    return _ref5.apply(this, arguments);
  };
}());
exports.fetchUpdateOrder = fetchUpdateOrder;
var fetchUpdateCoupon = (0, _toolkit.createAsyncThunk)('order/updateCoupon', /*#__PURE__*/function () {
  var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(_ref6, _ref7) {
    var id, couponCode, rejectWithValue, _yield$updateOrder2, order;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          id = _ref6.id, couponCode = _ref6.couponCode;
          rejectWithValue = _ref7.rejectWithValue;
          _context3.prev = 2;
          _context3.next = 5;
          return (0, _api.updateOrder)(id, {
            couponCode: couponCode
          });
        case 5:
          _yield$updateOrder2 = _context3.sent;
          order = _yield$updateOrder2.order;
          return _context3.abrupt("return", order);
        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](2);
          return _context3.abrupt("return", rejectWithValue(_context3.t0.message));
        case 13:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[2, 10]]);
  }));
  return function (_x5, _x6) {
    return _ref8.apply(this, arguments);
  };
}());
exports.fetchUpdateCoupon = fetchUpdateCoupon;
var fetchGetOrder = (0, _toolkit.createAsyncThunk)('order/getOrder', /*#__PURE__*/function () {
  var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(id, _ref9) {
    var rejectWithValue, _yield$getOrder, order;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          rejectWithValue = _ref9.rejectWithValue;
          _context4.prev = 1;
          _context4.next = 4;
          return (0, _api.getOrder)(id);
        case 4:
          _yield$getOrder = _context4.sent;
          order = _yield$getOrder.order;
          return _context4.abrupt("return", order);
        case 9:
          _context4.prev = 9;
          _context4.t0 = _context4["catch"](1);
          return _context4.abrupt("return", rejectWithValue(_context4.t0.message));
        case 12:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[1, 9]]);
  }));
  return function (_x7, _x8) {
    return _ref10.apply(this, arguments);
  };
}());
exports.fetchGetOrder = fetchGetOrder;
var orderSlice = (0, _toolkit.createSlice)({
  name: 'order',
  initialState: initialState,
  reducers: {},
  extraReducers: (_extraReducers = {}, (0, _defineProperty2.default)(_extraReducers, fetchCreateOrder.pending, function (state) {
    state.loading = true;
  }), (0, _defineProperty2.default)(_extraReducers, fetchCreateOrder.fulfilled, function (state, _ref11) {
    var payload = _ref11.payload;
    state.loading = false;
    state.order = payload;
  }), (0, _defineProperty2.default)(_extraReducers, fetchCreateOrder.rejected, function (state, _ref12) {
    var payload = _ref12.payload;
    state.loading = false;
    state.error = payload;
  }), (0, _defineProperty2.default)(_extraReducers, fetchGetOrder.pending, function (state) {
    state.loading = true;
  }), (0, _defineProperty2.default)(_extraReducers, fetchGetOrder.fulfilled, function (state, _ref13) {
    var payload = _ref13.payload;
    state.loading = false;
    state.order = payload;
  }), (0, _defineProperty2.default)(_extraReducers, fetchGetOrder.rejected, function (state) {
    state.loading = false;
  }), (0, _defineProperty2.default)(_extraReducers, fetchUpdateCoupon.pending, function (state) {
    state.isCouponLoading = true;
    state.couponDetails = {
      showMessage: false,
      message: '',
      messageType: _Input.MESSAGE_TYPE_SUCCESS
    };
  }), (0, _defineProperty2.default)(_extraReducers, fetchUpdateCoupon.fulfilled, function (state, _ref14) {
    var payload = _ref14.payload;
    state.isCouponLoading = false;
    state.order = payload;
    state.couponDetails = {
      showMessage: true,
      message: 'Your coupon has been applied!',
      messageType: _Input.MESSAGE_TYPE_SUCCESS
    };
  }), (0, _defineProperty2.default)(_extraReducers, fetchUpdateCoupon.rejected, function (state, _ref15) {
    var payload = _ref15.payload;
    state.isCouponLoading = false;
    state.couponError = payload;
    state.couponDetails = {
      showMessage: true,
      message: 'This is not a valid coupon code for this offer. Please check the code on your coupon and try again.',
      messageType: _Input.MESSAGE_TYPE_FAIL
    };
  }), (0, _defineProperty2.default)(_extraReducers, fetchUpdateOrder.pending, function (state) {
    state.isUpdateLoading = true;
  }), (0, _defineProperty2.default)(_extraReducers, fetchUpdateOrder.fulfilled, function (state, _ref16) {
    var payload = _ref16.payload;
    state.isUpdateLoading = false;
    state.order = payload;
  }), (0, _defineProperty2.default)(_extraReducers, fetchUpdateOrder.rejected, function (state, _ref17) {
    var payload = _ref17.payload;
    state.isUpdateLoading = false;
    state.error = payload;
  }), _extraReducers)
});
exports.orderSlice = orderSlice;
var _default = orderSlice.reducer;
exports.default = _default;